import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import convertTimeStampToDate from '@/common/utils/convertTimeStampToDate';
import { FileEntryQueryResponseType } from '@/modules/FileDetail/queries/fileEntry/fileEntryQuery.type.ts';
import { css } from 'styled-system/css';

export default (data: FileEntryQueryResponseType): DetailCardItemData[] => {
  return [
    {
      type: 'default',
      keyName: 'شناسه پرونده',
      value: data.order_id,
      dirLtr: true,
    },
    { type: 'default', keyName: 'وضعیت پرونده', value: data.status?.fa_const },
    {
      type: 'default',
      valueClassName: !data.visit_date
        ? css({ color: 'red-1', textStyle: 'b2' })
        : undefined,
      keyName: 'زمان بازدید ',
      value: data.visit_date
        ? `${convertTimeStampToDate(data.visit_date, undefined, false)} -  ${data?.visit_time}`
        : 'تعیین نشده',
    },

    {
      type: 'default',
      keyName: `${data.related_file?.count} پرونده پیوست`,
      value: data.related_file?.has_related_file ? 'مشاهده' : '',
    },
  ];
};
